/* es6-map/implement */ function _(require, module, exports) {
    if (!require(373) /* ./is-implemented */()) {
        Object.defineProperty(require(329) /* es5-ext/global */, 'Map', { value: require(377) /* ./polyfill */, configurable: true, enumerable: false,
            writable: true });
    }
}
